import { render, staticRenderFns } from "./Resources.vue?vue&type=template&id=d00f80f2&scoped=true&"
import script from "./Resources.vue?vue&type=script&lang=js&"
export * from "./Resources.vue?vue&type=script&lang=js&"
import style0 from "./Resources.vue?vue&type=style&index=0&id=d00f80f2&scoped=true&lang=css&"
import style1 from "./Resources.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d00f80f2",
  null
  
)

export default component.exports